export const API_VERSION='v1'
export const SEND_STATS_INTERVAL_SECONDS=30